import React from "react";

const StatCard = ({ title, value, subtitle, change, trend, color = "blue" }) => {
  const colorClasses = {
    blue: "border-blue-500 bg-blue-50",
    green: "border-green-500 bg-green-50",
    purple: "border-purple-500 bg-purple-50",
    orange: "border-orange-500 bg-orange-50",
    pink: "border-pink-500 bg-pink-50",
    indigo: "border-indigo-500 bg-indigo-50",
    emerald: "border-emerald-500 bg-emerald-50",
    yellow: "border-yellow-500 bg-yellow-50",
  };

  const getTrendIcon = () => {
    if (trend === "up") return "↗";
    if (trend === "down") return "↘";
    return "→";
  };

  const getTrendColor = () => {
    if (trend === "up") return "text-green-600";
    if (trend === "down") return "text-red-600";
    return "text-gray-600";
  };

  return (
    <div
      className={`bg-white rounded-lg shadow p-6 border-l-4 ${
        colorClasses[color] || colorClasses.blue
      }`}
    >
      <div className="flex items-center">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600">{title}</p>
          <p className="text-3xl font-bold text-gray-900 mt-2">{value}</p>
          {subtitle && (
            <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
          )}
          {change && (
            <div className="flex items-center mt-2">
              <span className={`text-sm font-medium ${getTrendColor()}`}>
                {getTrendIcon()} {change}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatCard;


